import { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axiosInstance from '../../../../../../services/axios/axios';

//param @app : AppManagementModel
//param @setApp : function
const ApplicationTypeDropdown = ({ app, setApp }) => {
	//drop down component, options sourced from T_Username_Type

	const [options, setOptions] = useState([]);

	useEffect(() => {
		GetApplicationTypeOptions().then(options => {
			setOptions(options);
		});
	}, []);

	//set username type to first option in the dropdown if it is not already assigned
	//or else it wont be assigned until the dropdown changes
	useEffect(() => {
		if (
			app.UPMCApplication.UPMCAppType === null ||
			app.UPMCApplication.UPMCAppType === undefined
		) {
			setApp({
				...app,
				UPMCApplication: {
					...app.UPMCApplication,
					UPMCAppType: options[0]?.ID,
				},
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options]);

	const handleChange = e => {
		setApp({
			...app,
			UPMCApplication: {
				...app.UPMCApplication,
				UPMCAppType: e.target.value,
			},
		});
	};

	return (
		<Select
			labelId='ApplicationTypeDropdown'
			id='ApplicationTypeDropdown'
			value={
				app?.UPMCApplication?.UPMCAppType
					? app?.UPMCApplication?.UPMCAppType
					: options[0]?.ID
					? options[0]?.ID
					: ''
			}
			label='ApplicationType'
			onChange={handleChange}
		>
			{options.map(option => {
				return (
					<MenuItem key={option.ID} value={option.ID}>
						{option.Full}
					</MenuItem>
				);
			})}
		</Select>
	);
};

export default ApplicationTypeDropdown;

const GetApplicationTypeOptions = async () => {
	try {
		const response = await axiosInstance.get(
			`api/ApplicationManagement/misc/getApplicationTypes`
		);
		return response.data;
	} catch (ex) {
		console.error(
			'Unable to fetch username Types for UserName Type dropdown: ' + ex
		);
		return {
			data: {},
			error: 'An Error Occured Fetching data from the server',
		};
	}
};
